// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

// Api
import { Api } from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class FileExchangeModule extends ModuleBase {
  private isLoading: boolean = false;

  private isModalVisible: boolean = false;
  private isDeleteModalVisible: boolean = false;
  private isModalNewFile: boolean = false;

  private file: File | null = null;
  private fileId: string | null = null;

  private files: any[] = [];

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public async created() {
    await this.loadFileList();
  }

  public async destroyed() {
    this.$store.ui.closeAllMessages();
  }

  private async loadFileList() {
    try {
      this.isLoading = true;

      const response = await Api.katalogService.getFiles("ckd");

      this.files = response.resultList;
    } catch (e: any) {
      console.log(e);
      if (e.error) this.$store.ui.error(e.error.message);
    }

    setTimeout(() => (this.isLoading = false), 800);
  }

  private handleOpenModal(
    isNewFile: boolean = true,
    fileId: string | null = null
  ) {
    this.isModalNewFile = isNewFile;
    this.isModalVisible = true;
    this.fileId = fileId;
  }

  private handleOpenDeleteModal(fileId: string) {
    this.isDeleteModalVisible = true;
    this.fileId = fileId;
  }

  private handleCloseModal() {
    this.isModalNewFile = false;
    this.isModalVisible = false;
    this.file = null;
    this.fileId = null;
  }

  private handleCloseDeleteModal() {
    this.isDeleteModalVisible = false;
    this.fileId = null;
  }

  private async handleDeleteFile() {
    try {
      await Api.katalogService.deleteFile("ckd", this.fileId!);
      await this.loadFileList();
    } catch (e: any) {
      if (e.error) this.$store.ui.error(e.error.message);
    }

    this.handleCloseDeleteModal();
  }

  private async handleAddNewFile() {
    const isValid = await this.$validator.validate("file");

    if (!isValid) return;

    try {
      this.isLoading = true;
      await Api.katalogService.createFile("ckd", this.file);
      await this.loadFileList();
    } catch (e: any) {
      if (e.error) this.$store.ui.error(e.error.message);
    }

    this.handleCloseModal();

    setTimeout(() => (this.isLoading = false), 800);
  }

  private async handleUpdateFile() {
    const isValid = await this.$validator.validate("file");

    if (!isValid) return;

    try {
      this.isLoading = true;
      await Api.katalogService.updateFile("ckd", this.fileId!, this.file);
      await this.loadFileList();
    } catch (e: any) {
      if (e.error) this.$store.ui.error(e.error.message);
    }

    this.handleCloseModal();

    setTimeout(() => (this.isLoading = false), 800);
  }
}
